import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {
    IVoceSchedaCosto
} from "../../../../../../../../utils/interfaces/tannery_production/order_schedule/schede_costo/IVoceSchedaCosto";
import {CustomAxiosError, useApiCalls} from "../../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../../utils/contexts/auth-context";


const useApiCreateVoceSchedaCosto = (scheda_costo_id: number | undefined): UseMutationResult<IVoceSchedaCosto, CustomAxiosError, any> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {post} = useApiCalls()

    async function doCreate({companyToken, data}: {
        companyToken?: string,
        data: any
    }): Promise<IVoceSchedaCosto> {
        try {
            const response = await post(`/api/company/${companyToken}/tannery_production/schede_costo/schede_costo/${scheda_costo_id}/voci_scheda_costo/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<IVoceSchedaCosto, CustomAxiosError, any>(
        {
            mutationFn: (
                data
            ) => {
                return doCreate({
                    companyToken: selectedCompany?.company_token,
                    data
                })
            },
            onSuccess: async (obj) => {
                await queryClient.invalidateQueries({queryKey: ["useApiGetVociSchedaCosto", scheda_costo_id]});
            },
        }
    );
};


export default useApiCreateVoceSchedaCosto;